<!-- eslint-disable max-len -->
<template>
  <div v-if="isAccountLoaded">
    <div v-if="isTeamPlanNotFree" class="my-team__expiry-info">
      <span class="font-bold">{{ $i18nPresenter.t('Licenses used:') }}</span>
      <span>
        {{ licensesUsed }}
      </span>
      <span class="upgrade-link">
        <a class="sm:text-base-0 text-secondary-60 underline cursor-pointer" @click="onClickTeamPlan">{{ teamPlan.name }}</a>
      </span>
      <span v-if="account.planEndAt" class="expires">
        <span class="hidden sm:inline"> - </span>
        <br class="sm:hidden">
        <span class="font-bold">{{ $i18nPresenter.t('Expires:') }}</span>
        <span> {{ account.planEndAt | dateTimeStamp }}</span>
      </span>
    </div>
    <div v-else>
      <span class="font-bold">{{ $i18nPresenter.t('Live event participant limit:') }}</span>
      <span> {{ teamPlan.limit }}. </span>
      <br class="sm:hidden">
      <span class="upgrade-link" v-if="currentUserIsTeamOwnerOrAdmin">
        <a class="sm:text-base-0 text-secondary-60 underline cursor-pointer" @click="onClickUpgradeForMore">{{ $i18nPresenter.t('Upgrade for more') }}</a>
      </span>
    </div>
    <div v-if="teamPlanIsExpired" class="my-team__expiry-info ">
      <span class="font-bold">{{ $i18nPresenter.t('Your licences have expired') }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Pricing from '@/pricing'
import util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    account: {
      type: Object,
      default: () => {},
    },
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters([
      'currentUserIsTeamOwnerOrAdmin',
    ]),
    isAccountLoaded() {
      return this.account && this.account.id
    },
    isTeamPlanNotFree() {
      return this.account.id && this.account.plan !== 'free' && this.account.plan !== null
    },
    teamPlanIsExpired() {
      if (!this.account || !this.account.planEndAt) return false
      return moment().isAfter(moment(this.account.planEndAt), 'minute')
    },
    teamPlan() {
      return Pricing.getPlanByType(this.account?.plan || 'free')
    },

    isSelfCreateTeam() {
      return this.account && this.account.createdFrom === 'presenter'
    },
    licensesUsed() {
      if (!this.account) return null
      return `${this.$options.filters.formatNumber(this.account.numberOfUsedLicenses)}/${this.$options.filters.formatNumber(this.account.licenseQuantity)}`
    },
  },
  methods: {
    onClickUpgradeForMore() {
      util.trackGA4AndMixpanel('Team management > Upgrade for more', {
        eventCategory: eventCategories.MY_TEAM,
        eventAction: 'Team management > Upgrade for more',
      })
      this.$router.push('/apps/user-plan#bulk-pricing')
    },
    onClickTeamPlan() {
      util.trackGA4AndMixpanel('Team management > Plans & Billing', {
        eventCategory: eventCategories.MY_TEAM,
        eventAction: 'Team management > Plans & Billing',
      })
      this.$router.push('/apps/user-plan')
    },
  },
}
</script>

<style lang="scss" scoped>
.team-expiry-info-mobile {
  .upgrade-link {
    color: rgba(40, 46, 62, 1);
  }
}
</style>
